var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.15499 14.6406C3.69749 14.6406 3.26999 14.4831 2.96249 14.1906C2.57249 13.8231 2.38499 13.2681 2.45249 12.6681L2.72999 10.2381C2.78249 9.78065 3.05999 9.17315 3.38249 8.84315L9.53999 2.32565C11.0775 0.698147 12.6825 0.653147 14.31 2.19065C15.9375 3.72815 15.9825 5.33315 14.445 6.96065L8.28749 13.4781C7.97249 13.8156 7.38749 14.1306 6.92999 14.2056L4.51499 14.6181C4.38749 14.6256 4.27499 14.6406 4.15499 14.6406ZM11.9475 2.18315C11.37 2.18315 10.8675 2.54315 10.3575 3.08315L4.19999 9.60815C4.04999 9.76565 3.87749 10.1406 3.84749 10.3581L3.56999 12.7881C3.53999 13.0356 3.59999 13.2381 3.73499 13.3656C3.86999 13.4931 4.07249 13.5381 4.31999 13.5006L6.73499 13.0881C6.95249 13.0506 7.31249 12.8556 7.46249 12.6981L13.62 6.18065C14.55 5.19065 14.8875 4.27565 13.53 3.00065C12.93 2.42315 12.4125 2.18315 11.9475 2.18315Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.005 8.21263C12.99 8.21263 12.9675 8.21263 12.9525 8.21263C10.6125 7.98013 8.73002 6.20263 8.37002 3.87763C8.32502 3.57013 8.53502 3.28513 8.84252 3.23263C9.15002 3.18763 9.43502 3.39763 9.48752 3.70513C9.77252 5.52013 11.2425 6.91513 13.0725 7.09513C13.38 7.12513 13.605 7.40263 13.575 7.71013C13.5375 7.99513 13.29 8.21263 13.005 8.21263Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.75 17.0625H2.25C1.9425 17.0625 1.6875 16.8075 1.6875 16.5C1.6875 16.1925 1.9425 15.9375 2.25 15.9375H15.75C16.0575 15.9375 16.3125 16.1925 16.3125 16.5C16.3125 16.8075 16.0575 17.0625 15.75 17.0625Z",
    fill: "#858585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit-icon2.1d819bf6dcd466d8232f988da0bcc0a5.svg";
export { ForwardRef as ReactComponent };